import Head from "next/head";
import {
  buildCanonicalUrl,
  getSiteUrl,
  ROBOTS_INDEX,
  SITE_NAME,
  type ROBOTS_NOINDEX,
} from "@/lib/siteSeo";

type RobotsDirective = typeof ROBOTS_INDEX | typeof ROBOTS_NOINDEX;

type PageSeoHeadProps = {
  title: string;
  description?: string;
  path: string;
  robots?: RobotsDirective;
  ogImage?: string;
};

export function PageSeoHead({
  title,
  description,
  path,
  robots = ROBOTS_INDEX,
  ogImage,
}: PageSeoHeadProps) {
  const canonical = buildCanonicalUrl(path);
  const siteUrl = getSiteUrl();
  const image = ogImage ?? `${siteUrl}/images/logo.png`;

  return (
    <Head>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={robots} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      {description ? (
        <meta property="og:description" content={description} />
      ) : null}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="pt_BR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description ? (
        <meta name="twitter:description" content={description} />
      ) : null}
      <meta name="twitter:image" content={image} />
    </Head>
  );
}
